import React, { useState } from "react";
import { FormLabel } from "react-bootstrap";

const tagCategories = {
  "Condition & Completeness": [
    "Acceptable",
    "Box Only",
    "Brand New",
    "Cartridge Only",
    "Complete in Box",
    "Excellent",
    "For parts",
    "Good",
    "New",
    "Not working",
    "Open Box",
    "Raw",
    "Restored",
    "Sealed",
    "Used",
    "Very Good",
  ],

  "Development & Pre-Release": [
    "Beta Copy",
    "Debug",
    "Demo",
    "Dev Console",
    "Prototype",
    "Test Market",
  ],

  "Edition & Rarity": [
    "1 of 1",
    "1st Edition",
    "Collectors Edition",
    "Complete Edition",
    "Discontinued",
    "First Print",
    "Game Of The Year Edition",
    "Gold Edition",
    "Greatest Hits",
    "Launch Edition",
    "Limited Edition",
    "Player's Choice",
    "Premium Edition",
    "Special Edition",
    "SteelBook Edition",
    "Ultimate Edition",
    "Uncirculated",
  ],

  "Grading & Authentication": [
    "Beckett Grading Services (BGS)",
    "Certified Guaranty Company (CGC)",
    "Graded",
    "Professional Sports Authenticator (PSA)",
    "Sportscard Guaranty (SCG)",
    "TAG",
    "WATA",
    "VGA",
    "Certificate of Authenticity (COA)",
  ],

  "VHS & Home Media": [
    "Watermark Sealed",
    "First Print (VHS)",
    "Screener",
    "Slipcover",
    "Clamshell",
    "Betamax",
    "LaserDisc",
  ],

  "Arcade & Pinball": [
    "Arcade (Sit Down)",
    "Arcade (Upright)",
    "Cocktail Arcade",
    "Solid State",
    "Electro-Mechanical (EM)",
    "Coin-Op",
    "Playfield",
    "Backglass",
    "Topper",
  ],

  "Art, Props & Memorabilia": [
    "Screen-Used",
    "Production Asset",
    "Replica",
    "Original Sketch",
    "Animation Cel",
    "Storyboards",
    "Lithograph",
    "Signed / Autographed",
    "Cast & Crew Exclusive",
  ],

  "Statues & Figures": [
    "Life-Size",
    "1:4 Scale",
    "1:6 Scale",
    "Resin",
    "Vinyl",
    "Bust",
    "Action Figure",
    "Bobblehead",
  ],

  "Platform & Brand": [
    "Astrocade",
    "Atari",
    "Atari 2600",
    "Atari 5200",
    "ColecoVision",
    "GameBoy",
    "GameBoy Advance",
    "GameBoy Advance SP",
    "GameBoy Color",
    "GameCube",
    "Intellivision",
    "Magnavox Odyssey 2",
    "N64",
    "Nintendo",
    "World of Nintendo",
    "Nintendo 3DS",
    "Nintendo 3DS XL",
    "Nintendo DS",
    "Nintendo DS XL",
    "Nintendo DSi",
    "Nintendo DSi XL",
    "Nintendo Entertainment System",
    "Nintendo Game & Watch",
    "Nintendo Switch",
    "Nintendo Switch 2",
    "PlayStation",
    "PlayStation 2",
    "PlayStation 3",
    "PlayStation 4",
    "PlayStation 5",
    "PlayStation Vita",
    "Sega",
    "Sony",
    "Super Nintendo Entertainment System",
    "Vectrex",
    "VirtualBoy",
    "Wii",
    "Wii U",
    "Xbox",
    "Xbox 360",
    "Xbox One",
    "Xbox Series S",
    "Xbox Series X",
  ],

  "Promotional & Display Items": [
    "Countertop Display",
    "Countertop Kiosk",
    "Display",
    "Display Case",
    "Fiber Optic Sign",
    "Full-size Kiosk",
    "Full-size Standee",
    "Marketing Material",
    "Neon Sign",
    "Nintendo Sign",
    "Official Showcase",
    "PlayStation Sign",
    "Press Kit",
    "Promo Only",
    "Sega Sign",
    "Superbrite Sign",
    "World Of Nintendo",
    "Xbox Sign",
  ],

  "Provenance & Exclusivity": [
    "Convention Exclusive",
    "E3 Exclusive",
    "Employee Award/Item",
    "Giveaway Prize",
    "Movie Premier",
    "National Championship",
    "Nintendo of America Exclusive",
    "Not for Resale",
    "Pokémon Center Exclusive",
    "Rep Only",
    "Sweepstakes Prize",
    "Tournament Exclusive",
  ],
};


const TagSelector = ({ selectedTags, onTagsChange }) => {

     const tagDefaultStyle = {
    background: '#f8f9fa', 
    border: '1px solid #dee2e6',
    color: '#212529',
    margin: '0.25rem',
    padding: '0.3rem 0.75rem',
    borderRadius: '50rem', 
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  };
  
  const tagSelectedStyle = {
    ...tagDefaultStyle, 
    background: 'var(--yellow-color, #ffc107)', 
    color: '#000',
    borderColor: 'var(--yellow-color, #ffc107)',
  };

  const handleTagClick = (tag) => {
    let newTags;
    if (selectedTags.includes(tag)) {
      newTags = selectedTags.filter(t => t !== tag);
    } else {
      newTags = [...selectedTags, tag];
    }
    onTagsChange(newTags);
  };
  return (
    <div className="col-md-12 mb-4">
      <FormLabel className="text-dark fw-600">Select Tags</FormLabel>
      <div className="form-text mb-2">Choose tags that apply to your item. This helps buyers find that grail they've been looking for.</div>

      {Object.entries(tagCategories).map(([category, tags]) => (
        <div key={category} className="mb-3">
          <h6 className="text-muted">{category}</h6>
          <div className="tag-container">
            {tags.map((tag) => (
              <button
                key={tag}
                type="button"
                style={selectedTags.includes(tag) ? tagSelectedStyle : tagDefaultStyle}
                onClick={() => handleTagClick(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TagSelector;